import PptxGenJS from 'pptxgenjs'
import { copyrightTitle } from './utils'

export const batchExportPPTX = async (charts, filters) => {
  const pres = new PptxGenJS()
  let addingPromise = []

  charts.map(chartOBj => {
    addingPromise.push(
      addSlide(pres, chartOBj, chartOBj.chartElement || chartOBj, filters),
    )
  })

  await Promise.all(addingPromise)
  makeLastSlide(pres)
  await pres.writeFile({ fileName: 'Report-charts.pptx' })
}

const makeLastSlide = pptxgenInstance => {
  /**
   * The last slide
   * @type {PptxGenJS.Slide}
   */
  const slide = pptxgenInstance.addSlide()
  slide.addText('Disclaimer', {
    x: 0.5,
    y: 0.5,
    w: '50%',
    h: 0.5,
    fontFace: 'Barlow-Bold',
    fontSize: 22,
    color: '#004BC7',
    valign: 'bottom',
  })
  slide.addText(
    'Copyright © 2023 by CEM Benchmarking Inc. (\'CEM\'). The information in this document is sourced from CEM\'s dashboard by ' +
    'an end user. This document has not been reviewed by CEM staff and is not guaranteed to be the optimal fit for your ' +
    'purpose. Although the information in this document has been based upon and obtained from sources we believe to be ' +
    'reliable, CEM does not guarantee its accuracy or completeness. The information contained herein is proprietary and ' +
    'confidential and may not be disclosed to third parties without the express written mutual consent of CEM. ' +
    'If using CEM data for external or publication purposes, CEM expects to first review the document and requires proper ' +
    'recognition as the source for the data.',
    {
      x: 0.5,
      y: 1,
      w: '90%',
      h: 0.5,
      valign: 'top',
      fontFace: 'Barlow-Light',
      fontSize: 12,
    },
  )
  addCopyrightText(slide)
}
const addSlide = async (pptxInstance, chartProps, chartElement, filters) => {
  let slide = pptxInstance.addSlide()
  const svgData = chartElement.chart.getSVG()
  const encodedData = btoa(unescape(encodeURIComponent(svgData)))

  slide.addImage({
    data: `data:image/svg+xml;base64,${encodedData}`,
    w: '50%',
    h: '60%',
    x: '5%',
    y: '25%',
  })
  slide.addText(chartProps.title, {
    x: 0.5,
    y: 0.5,
    w: '60%',
    h: 0.5,
    fontFace: 'Barlow-Bold',
    fontSize: 22,
    color: '#004BC7',
    valign: 'bottom',
    shrinkText: true,
  })

  slide.addText(chartProps.caption.title, {
    x: '60%',
    y: '22%',
    w: '35%',
    h: 0.8,
    fontFace: 'Barlow-Bold',
    bold: true,
    valign: 'top',
    fontSize: 18,
    shrinkText: true,
  })

  slide.addText(chartProps.caption.text, {
    x: '60%',
    y: '35%',
    w: '35%',
    h: '60%',
    fontFace: 'Barlow-Light',
    valign: 'top',
    fontSize: 12,
    isTextBox: true,
    shrinkText: true,
  })

  addCopyrightText(slide)

  slide.addText((filters || chartProps.filters)?.join(', '), {
    x: '60%',
    y: '90%',
    fontFace: 'Barlow-Light',
    fontSize: 11,
    color: '#BFBFBF',
    w: '35%',
    valign: 'top',
  })
}

const addCopyrightText = slide => {
  slide.addImage({
    data: 'data:image/png;base64,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',
    w: '8%',
    h: '6%',
    x: '5%',
    y: '89%',
    sizing: {
      type: 'contain',
    },
  })

  slide.addText(copyrightTitle, {
    x: '13%',
    y: '90%',
    w: '50%',
    h: '4%',
    fontFace: 'Barlow-Light',
    fontSize: 11,
    color: '#BFBFBF',
    valign: 'top',
  })
}
